import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getAccountProxyLink} from 'src/openapi/admin/apis/GetAccountProxyLinkApi';
import {updateAccountProxyLink} from 'src/openapi/admin/apis/UpdateAccountProxyLinkApi';
import {useAppDispatch} from 'src/store/hooks';

import {useValidateEZProxy} from './useValidateEZProxy';

import type {ProxyLink} from 'src/openapi/admin/models/ProxyLink';

type Props = {
    accountId: number,
};

export const useEzProxy = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const {onValidateEZProxy} = useValidateEZProxy();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccountProxyLink({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((proxyLink: ProxyLink) => apiDispatch(
        updateAccountProxyLink({accountId, proxyLink: proxyLink.value}),
    ), [accountId, apiDispatch]);

    const editValidation = useCallback((proxyLink: ProxyLink) => {
        if (proxyLink.value !== undefined) {
            onValidateEZProxy(proxyLink.value);
        }
    }, [onValidateEZProxy]);

    return useCommonDataHook({
        initValue: {value: ''},
        getDispatchAction,
        saveDispatchAction,
        editValidation,
    });
};
